import { Button } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';

export function DeleteConfirmation({ title, description, showFlag, onClose, onConfirmation }) {
    return (
      <Modal centered show={showFlag} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body>{description}</Modal.Body>
        <Modal.Body className="delete-item-confirmation">{title}</Modal.Body>
        <Modal.Body>This action cannot be undone.</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
          <Button variant="danger" onClick={onConfirmation}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal >
    );
}
